import { createSlice } from "@reduxjs/toolkit";
import {
  communicateBack,
  communicateBackCancelledServices,
} from "./communicationFormActions";

const initialState = {
  loading: false,
  cancelledServicesLoading: false,
};

const communicationFormSlice = createSlice({
  name: "communicationForm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(communicateBack.pending, (state) => {
        state.loading = true;
      })
      .addCase(communicateBack.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(communicateBack.rejected, (state) => {
        state.loading = false;
      })
      .addCase(communicateBackCancelledServices.pending, (state) => {
        state.cancelledServicesLoading = true;
      })
      .addCase(communicateBackCancelledServices.fulfilled, (state) => {
        state.cancelledServicesLoading = false;
      })
      .addCase(communicateBackCancelledServices.rejected, (state) => {
        state.cancelledServicesLoading = false;
      });
  },
});

export default communicationFormSlice.reducer;
